import React, { useEffect, useRef, useState } from 'react';

export function requiresAuthConsent(hostname, appEdition) {
  return hostname === 'app.mfe.llc' || appEdition === 'military';
}

// Mount only for an unauthenticated session. Consent lasts for this attempt,
// not across logout, session expiry, page reloads, or new browser tabs.
export default function AuthConsentGate({ required = true, children }) {
  const [acknowledged, setAcknowledged] = useState(false);
  const headingRef = useRef(null);
  const controlsRef = useRef(null);

  useEffect(() => {
    if (required && !acknowledged) headingRef.current?.focus();
    if (required && acknowledged) {
      controlsRef.current?.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled])')?.focus();
    }
  }, [required, acknowledged]);

  if (!required) return children;
  if (acknowledged) return <div ref={controlsRef}>{children}</div>;

  return (
    <main className="auth-shell" aria-labelledby="auth-consent-heading">
      <section className="auth-card auth-consent">
        <div className="auth-card__intro">
          <a className="auth-card__logo-link" href="https://mfe.llc" aria-label="Mission Focused Ethos home">
            <img src="/mfe-logo-transparent.png" alt="MFE" className="auth-card__logo" />
          </a>
          <span className="auth-card__eyebrow">Mission Focused Ethos</span>
        </div>
        <h2 id="auth-consent-heading" ref={headingRef} tabIndex={-1}>Notice and Consent</h2>
        <p>You are accessing an application owned by Mission Focused Ethos. Access is limited to authorized US Government users, its agents, and only for authorized purposes.</p>
        <p>Activity may be logged, monitored, and reviewed to protect the application and investigate misuse. Use only information you are authorized to access or share. Do not upload classified information.</p>
        <p>By selecting <strong>Okay</strong>, you acknowledge this notice and consent to the monitoring described above.</p>
        <button type="button" onClick={() => setAcknowledged(true)}>Okay</button>
      </section>
    </main>
  );
}
